import { HttpClient } from 'api/http-client';
class HolidayCalendarHttpClient extends HttpClient {
    getHolidayCalendars() {
        return this.get('/holiday-calendar');
    }
    getHolidayCalendar(calendarId) {
        return this.get(`/holiday-calendar/${calendarId}`);
    }
    createHolidayCalendar(holidayCalendar) {
        return this.post('/holiday-calendar', holidayCalendar);
    }
    editHolidayCalendar(holidayCalendar) {
        return this.put('/holiday-calendar', holidayCalendar);
    }
    deleteHolidayCalendar(calendarId) {
        return this.delete(`/holiday-calendar/${calendarId}`);
    }
}
export const HolidayCalendarAPI = new HolidayCalendarHttpClient();
